import { gql } from "@apollo/client";

export const UPDATE_COMPANY_PROFILE = gql`
  mutation UpdateCompanyProfile($profile: String!) {
    updateCompanyProfile(profile: $profile) {
      id
      generatedProfile
    }
  }
`;